import { Button } from 'common/Components/Button';
import Captcha from 'common/Components/Captcha';
import InputPin from 'common/Components/form/InputPin';
import { useReturnToApp } from 'common/hooks/returnToApp';
import { useRouter } from 'common/hooks/useRouter';
import { ChevronLeftIcon } from 'common/Icons';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import {
  useChangePasswordValidation,
  useGetChangePassword,
} from 'services/changePassword';
import {
  useForceChangePasswordRequest,
  useForceChangePasswordValidation,
} from 'services/forceChangePassword';
import { useGetCaptch } from 'services/login';

//*type
export interface formDateType {
  otpValue: string;
  captchaValue: string;
}

/** need 
  if been temperoryToken , force means forse
  if been token means change-passwor

  if flow be false needs otpPage
*/

export const Form = () => {
  //*global
  const [otpValue, setOtpValue] = useState('');
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();
  const otpRes = otpValue.replaceAll(' ', '').replaceAll('_', '');

  const {
    autorizationSlice: { callBackUrl },
  } = useSelector((state: RootState) => state);

  const { pushReturn } = useReturnToApp();

  const {
    navigate,
    history: { state },
  } = useRouter();


  const { t } = useTranslation()

  //*form
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
    setValue,
    getValues
  } = useForm<formDateType>({
    defaultValues: {
      captchaValue: '',
    },
    mode: 'onChange',
  });

  const onSubmit: SubmitHandler<formDateType> = (data) => {
    if (!captcha?.key) {
      handleRefetchCaptch();
      return;
    }

    const reqData: reqChangePasswordValidationType = {
      otp: otpRes,
      captchaValue: data.captchaValue,
      captchaKey: captcha?.key,
    };

    if (state?.force) {
      mutateValidationForce({ ...reqData, token: state?.temperoryToken });
    } else {
      mutateVAlidation(reqData);
    }
  };

  //*handle Methode
  const handleOnChange = (value: string) => {
    setOtpValue(value);
  };

  const sendCodeAgain = () => {
    state?.temperoryToken ? refetchForce() : refetch();
  };

  const handleRefetchCaptch = (): void => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  //*Validation API
  const { mutate: mutateVAlidation } = useChangePasswordValidation({
    onSuccess: (data) => {
      /////////////////handle error of 200 status code/////////////////////////////

      //////////////if succeeded be true////////////////
      if (data.succeeded) {
        navigate.push('/change-password', {
          state: {
            ...state,
            otp: otpValue,
            flow: true,
          },
        });
      } else {
        // toast.error(data.errors);
        handleRefetchCaptch();
      }
    },
    onError: (err) => {
      handleRefetchCaptch();
    },
  });

  const { mutate: mutateValidationForce } = useForceChangePasswordValidation({
    onSuccess: (data) => {
      /////////////////handle error of 200 status code/////////////////////////////

      //////////////if succeeded be true////////////////
      if (data.succeeded) {
        navigate.push('/change-password', {
          state: {
            ...state,
            otp: otpValue,
            flow: true,
            temperoryToken: state?.temperoryToken,
          },
        });
      } else {
        // toast.error(data.errors);
        handleRefetchCaptch();
        if (data.errors?.[0] === 'InvalidRequest') {
          // toast.error('توکن شما منقصی شده است');
          const clear = setTimeout(() => {
            navigate.pushLogin();
            clearTimeout(clear);
          }, 2000);
        }
      }
    },
    onError: (err) => {
      handleRefetchCaptch();
    },
  });

  //*UserDate Api
  const { data, refetch } = useGetChangePassword(state.force);

  const { data: dataForce, refetch: refetchForce } =
    useForceChangePasswordRequest({
      token: state?.temperoryToken,
      force: !!state.force,
    });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <p className="text-xl md:text-b2xl xl:text-2xl md:font-medium xl:font-medium text-L-gray-250  my-6">
        <Trans
          i18nKey={`FormSide.Input.OTP.Placeholder`}
          values={{
            n: state?.temperoryToken
              ? dataForce?.result?.starredMessage
              : data?.result?.starredMessage,
          }}
          components={{ tag: <span className="inline-block ltr p-1" /> }}
        />
      </p>
      <InputPin
        sendCodeAgain={sendCodeAgain}
        value={otpValue}
        onChange={handleOnChange}
        expireDate={
          state?.temperoryToken
            ? dataForce?.result?.expireDate
            : data?.result?.expireDate
        }
      />

      <Captcha
        register={register}
        errors={errors}
        captcha={captcha}
        onRefresh={handleRefetchCaptch}
        className="mt-24 md:mt-16"
        setValue={setValue}
        getValues={getValues}
      />

      <div className="mt-8">
        <Button
          type="submit"
          className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2 text-3xl md:text-2xl md:font-medium flex justify-center items-center gap-3"
        >
          <span>{t(`FormSide.NextStepButton`)}</span>
          <ChevronLeftIcon width={24} height={24} />
        </Button>
        <Button
          type="button"
          className="w-full mt-2 md:mt-4 text-L-gray-300 text-3xl md:text-xl"
          onClick={(event) => {
            event.preventDefault();
            pushReturn(callBackUrl)
          }}
        >
          {t(`FormSide.CancelText`)}
        </Button>
      </div>
    </form>
  );
};
